module.exports = __webpack_public_path__ + "static/euforia_top_back-c86314435870ff3718f1283e6456cee8.png";